import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import router from "@/router"
// import { getToken, setToken } from "@/utils/auth";

// 根据当前页面协议动态配置接口地址
function getProtocol() {
  return window.location.protocol;
}

function getBaseUrl(httpUrl, httpsUrl) {
  const protocol = getProtocol();
  const isHttps = protocol === 'https:';
  
  // 如果是HTTPS环境但没有配置HTTPS地址，使用HTTP地址
  const finalUrl = isHttps ? (httpsUrl || httpUrl) : httpUrl;
  
  // 开发环境下打印协议切换信息
  if (process.env.NODE_ENV === 'development') {
    console.log(`[API Protocol] Current: ${protocol}, Using: ${finalUrl}`);
    
    // 如果在HTTPS环境下使用HTTP接口，给出警告
    if (isHttps && finalUrl.startsWith('http://')) {
      console.warn(`[API Protocol Warning] Using HTTP API (${finalUrl}) in HTTPS environment. This may cause mixed content issues.`);
    }
  }
  
  return finalUrl;
}

// 添加一个辅助函数来检查是否存在协议混合问题
export function checkMixedContentIssues() {
  const protocol = getProtocol();
  const isHttps = protocol === 'https:';
  
  if (isHttps) {
    const httpUrls = [];
    Object.keys(URL_ENV).forEach(key => {
      if (URL_ENV[key].startsWith('http://')) {
        httpUrls.push(`${key}: ${URL_ENV[key]}`);
      }
    });
    
    if (httpUrls.length > 0) {
      console.warn('[Mixed Content Warning] The following APIs are using HTTP in HTTPS environment:', httpUrls);
      return httpUrls;
    }
  }
  
  return [];
}

// 服务器配置 - 根据实际情况配置HTTPS地址
const SERVER_CONFIG = {
  serverHost: {
    http: "http://47.98.232.4:7078",
    https: null // IP地址通常不支持HTTPS证书，设置为null使用HTTP
  },
  outServerHost: {
    http: "http://gtp_index_api.ouraivision.com",
    https: "https://gtp_index_api.ouraivision.com"
  },
  imgServerHost: {
    http: "http://openai.ouraivision.com",
    https: "https://openai.ouraivision.com"
  },
  gptServerHost: {
    http: "http://openai.ouraivision.com",
    https: "https://openai.ouraivision.com"
  },
  lsfgptServerHost: {
    http: "http://39.103.228.66:20001",
    https: null // IP地址通常不支持HTTPS证书，设置为null使用HTTP
  },
  chatDevServerHost: {
    http: "http://aichat.ouraivision.com",
    https: "https://aichat.ouraivision.com"
  },
  testServerHost: {
    http: "http://39.103.228.66:28200",
    https: null // IP地址通常不支持HTTPS证书，设置为null使用HTTP
  },
  conversationHost: {
    http: "http://39.103.228.66:10000",
    https: null // IP地址通常不支持HTTPS证书，设置为null使用HTTP
  },
  agentDemoHost: {
    http: "http://39.103.228.66:8184",
    https: "https://39.103.228.66:8184" // IP地址通常不支持HTTPS证书，设置为null使用HTTP
  }
};

// 创建URL_ENV对象，支持动态协议切换
export const URL_ENV = {
  serverHost: getBaseUrl(SERVER_CONFIG.serverHost.http, SERVER_CONFIG.serverHost.https),
  outServerHost: getBaseUrl(SERVER_CONFIG.outServerHost.http, SERVER_CONFIG.outServerHost.https),
  imgServerHost: getBaseUrl(SERVER_CONFIG.imgServerHost.http, SERVER_CONFIG.imgServerHost.https),
  gptServerHost: getBaseUrl(SERVER_CONFIG.gptServerHost.http, SERVER_CONFIG.gptServerHost.https),
  lsfgptServerHost: getBaseUrl(SERVER_CONFIG.lsfgptServerHost.http, SERVER_CONFIG.lsfgptServerHost.https),
  chatDevServerHost: getBaseUrl(SERVER_CONFIG.chatDevServerHost.http, SERVER_CONFIG.chatDevServerHost.https),
  testServerHost: getBaseUrl(SERVER_CONFIG.testServerHost.http, SERVER_CONFIG.testServerHost.https),
  conversationHost: getBaseUrl(SERVER_CONFIG.conversationHost.http, SERVER_CONFIG.conversationHost.https),
  agentDemoHost: getBaseUrl(SERVER_CONFIG.agentDemoHost.http, SERVER_CONFIG.agentDemoHost.https)
};

// 提供一个函数来动态更新特定服务的URL（如果需要运行时调整）
export function updateServerUrl(serverKey, httpUrl, httpsUrl) {
  if (SERVER_CONFIG[serverKey]) {
    SERVER_CONFIG[serverKey].http = httpUrl;
    SERVER_CONFIG[serverKey].https = httpsUrl;
    URL_ENV[serverKey] = getBaseUrl(httpUrl, httpsUrl);
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`[API Config] Updated ${serverKey} to: ${URL_ENV[serverKey]}`);
    }
  }
}
const service = axios.create({
  baseURL: URL_ENV.serverHost,
  // timeout: 10000, // 10s
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});
let conf = {}
// request interceptor
service.interceptors.request.use(
  config => {
    conf = config
    // 请求头携带token
    // if (getToken()) {
    //   config.headers["token"] = getToken();
    // }
    if (!config.noAuth) {
      if (localStorage.getItem('gptToken')) {
        config.headers["token"] = localStorage.getItem('gptToken')
      } else {
        router.push({
          path: '/gptlogin',
          query: router.history.current.query
        })
      }
    } else if (config.url.indexOf('chat/get-answer') != -1) {
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/gpt_index') != -1) {
      config.baseURL = URL_ENV.outServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/chatgpt/img') != -1) {
      config.baseURL = URL_ENV.imgServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/chatgpt/v1') != -1) {
      config.baseURL = URL_ENV.gptServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/faq2') != -1 || config.url.indexOf('/faq3') != -1) {
      config.baseURL = URL_ENV.lsfgptServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/faq5') != -1) {
      config.baseURL = URL_ENV.chatDevServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/faq') != -1) {
      config.baseURL = URL_ENV.lsfgptServerHost
      config.headers["platform"] = 'wx'
    } else if (config.url.indexOf('/feedback') != -1) {
      config.baseURL = URL_ENV.testServerHost
    } else if (config.env == 'prod') {
      config.baseURL = URL_ENV.lsfgptServerHost
    } else if (config.env == 'dev') {
      config.baseURL = URL_ENV.chatDevServerHost
    } else if (config.url.indexOf('/PositionSort') != -1 || config.url.indexOf('/possibly-ask') != -1 || config.url.indexOf('/func-introduce') != -1) {
      config.baseURL = URL_ENV.chatDevServerHost
    } else if (config.url.indexOf('/conversation/page-conversation') != -1 || config.url.indexOf('/conversation/insert') != -1 || config.url.indexOf('/conversation/page-history') != -1 || config.url.indexOf('/conversation/add-hisotry') != -1 || config.url.indexOf('/conversation/del') != -1) {
      config.baseURL = URL_ENV.conversationHost
    } else if (config.url.indexOf('/api/conversations') != -1 || config.url.indexOf('/api/chat') != -1) {
      config.baseURL = URL_ENV.agentDemoHost
    }

    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (conf.url.indexOf('/chatgpt/img') != -1 || conf.url.indexOf('/feedback') != -1 || conf.url.indexOf('/possibly-ask') != -1) {
      return response
    } else if (conf.url.indexOf('/api/') != -1) {
      // 新的Agent Demo API直接返回响应，不检查code
      return response;
    } else if (res.code == 200) {
      return response;
    } else if (res.code == 21001) {
      Message({
        message: res.message,
        type: "error",
        duration: 1 * 1000
      });
      setTimeout(() => {
        router.push({
          path: '/gptlogin',
          query: router.history.current.query
        })
      }, 1000);
    } else {
      Message({
        message: res.message,
        type: "error",
        duration: 2 * 1000
      });
    }

  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: "网络不给力，请稍后再试",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/requestgpt.js